
<div class="snackbar" [class.success]="isSuccess" [class.fail]="isFail" (click)="closeSnackbar()">
  <mat-icon class="info-icon" [svgIcon]="svgIconsEnum.InfoIcon"></mat-icon>
  <div class="title">
    {{message | translate}}
  </div>
  <mat-icon [svgIcon]="svgIconsEnum.Cross" class="close-icon" (click)="closeSnackbar()"></mat-icon>
</div>
